import { studioSelectionSummary } from 'src/components/star-grid/utils/studioMultiselect';
import React from 'react';
import { StudioParameterMembers } from 'src/components/star-grid/components/StudioParameterMembers';
import Button from '@amzn/awsui-components-core/button';
import Modal from '@amzn/awsui-components-core/modal';
import type { ReportParameter } from 'src/components/star-grid/reportDefinition.types';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { useStudioParameter } from 'src/components/star-grid/hooks/useStudioParameter';
import { ReportParameterField } from 'src/components/star-grid/components/ReportParameterField';
import { ReportParameterFilter } from 'src/components/star-grid/components/ReportParameterFilter';
import { useReportParameter } from 'src/components/star-grid/hooks/useReportParameter';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';
interface Props {
  readonly compact?: boolean;
  readonly parameter: ReportParameter;
  readonly state: ReportStudioState;
}
export const StudioParameterPill: React.FC<Props> = ({ compact, parameter, state }) => {
  const values = state.draft.definition.parameters[parameter.key] ?? parameter.default;
  const field = useStudioParameter(parameter, values);
  // The preview's filter bar behaves like the saved report's: a dropdown you open and pick from in
  // place. It used to be a button that threw a modal over the grid you were trying to filter, so you
  // could not see the effect of a choice while making it.
  const previewParameter = useReportParameter(parameter, values, compact === true);
  return (
    <div className={compact ? undefined : styles.filterPill}>
      {compact ? (
        <ReportParameterFilter
          parameter={parameter}
          values={values}
          state={previewParameter}
          onChange={(key, selected) => state.definition({ parameters: { ...state.draft.definition.parameters, [key]: selected } })}
        />
      ) : (
        <div className={styles.cardActions}>
          <strong>{parameter.label}</strong>
          <span className={styles.filterSummary} title={field.summary}>
            {field.summary || state.text('studioSelection_all')}
          </span>
          <Button variant="inline-link" onClick={() => field.setOpen(true)}>
            {state.text('studioEdit')}
          </Button>
        </div>
      )}
      <Modal
        visible={field.open}
        size={parameter.hierarchy_id ? 'large' : 'medium'}
        header={parameter.label}
        closeAriaLabel={state.text('studioClose')}
        onDismiss={() => field.setOpen(false)}
        footer={!parameter.hierarchy_id && <Button onClick={() => field.setOpen(false)}>{state.text('studioDone')}</Button>}
      >
        {field.open && parameter.hierarchy_id ? (
          <StudioParameterMembers
            parameter={parameter}
            values={values}
            text={state.text}
            onDismiss={() => field.setOpen(false)}
            onChange={(key, selected) => state.definition({ parameters: { ...state.draft.definition.parameters, [key]: selected } })}
          />
        ) : (
          field.open && (
            <ReportParameterField
              parameter={parameter}
              values={values}
              onChange={(key, selected) => state.definition({ parameters: { ...state.draft.definition.parameters, [key]: selected } })}
            />
          )
        )}
      </Modal>
    </div>
  );
};
